import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpParams} from "@angular/common/http";
import {UsersService} from "../../../core/customers/glotto-users.service";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'app-ganalottodo-user',
  templateUrl: './ganalottodo-user.component.html',
  styleUrls: ['./ganalottodo-user.component.scss']
})
export class GanalottodoUserComponent implements OnInit {
  changedWhiteList = false;
  changedBlock = false;
  isWhiteList = true;
  isLock = false;
  username;
  customer;
  justifyWhiteList;
  justifyLock;
  isLoading = false;

  mainBalance: number = null;
  awardsBalance: number = null;
  currency: string = null;
  migrated: boolean = null;
  transactions: any[] = [];
  isLoadingTransactions = false;

  pageSize = 10;
  currentPage = 0;

  showDeleteModal = false;
  deleteReason = '';
  isDeleting = false;

  get pagedTransactions(): any[] {
    const start = this.currentPage * this.pageSize;
    return this.transactions.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.transactions.length / this.pageSize));
  }

  walletLabel(walletType: string): string {
    if (walletType === 'main') return 'Principal';
    if (walletType === 'awards') return 'Premios';
    return '—';
  }

  hasPrev(): boolean { return this.currentPage > 0; }
  hasNext(): boolean { return (this.currentPage + 1) * this.pageSize < this.transactions.length; }
  prevPage() { if (this.hasPrev()) this.currentPage--; }
  nextPage() { if (this.hasNext()) this.currentPage++; }

  constructor(private activateRoute: ActivatedRoute,
              private usersService: UsersService,
              private router: Router,
              private messageService: MessageService) {
    this.username = this.activateRoute.snapshot.params['username'];
  }

  ngOnInit() {
    this.getUserInfo();
    this.getTransactions();
  }

  changeWhiteList() {
    return this.changedWhiteList !== this.isWhiteList;
  }

  changeBlock() {
    return this.changedBlock !== this.isLock;
  }

  getUserInfo() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('username', this.username);
    this.usersService.getGanalottodoCustomer(httpParams).subscribe(customer => {
      console.log('User info: ', customer);
      this.customer = customer;
      this.isWhiteList = this.customer.whiteList;
      this.isLock = this.customer.locked;
      this.changedBlock = this.isLock;
      this.changedWhiteList = this.isWhiteList;
    });
  }

  getTransactions() {
    this.isLoadingTransactions = true;
    this.usersService.getGanalottodoCustomerTransactions(this.username, 50).subscribe(
      response => {
        this.mainBalance = response.mainBalance;
        this.awardsBalance = response.awardsBalance;
        this.currency = response.currency;
        this.migrated = response.migrated;
        this.transactions = response.transactions || [];
        this.currentPage = 0;
        this.isLoadingTransactions = false;
      },
      error => {
        console.error('Error cargando transacciones:', error);
        this.isLoadingTransactions = false;
      }
    );
  }

  refreshTransactions() {
    this.getUserInfo();
    this.getTransactions();
  }

  verifyJustify() {
    return (this.changeWhiteList() && !this.justifyWhiteList) || (this.changeBlock() && !this.justifyLock);
  }

  update() {
    this.isLoading = true;
    const updateUserRequest = {
      username: this.username,
      whiteList: this.isWhiteList,
      justifyWhiteList: this.justifyWhiteList,
      lock: this.isLock,
      justifyLock: this.justifyLock
    };
    this.usersService.updateUser(updateUserRequest).subscribe(res => {
        this.isLoading = false;
        this.router.navigate(['ganalottodo', 'usuarios', 'ganalottodo']);
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Usuario: ' + updateUserRequest.username + ' actualizado correctamente.'
        });
      },
      error => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Error al actualizar.'
        });
      });
  }

  openDeleteModal() {
    this.showDeleteModal = true;
    this.deleteReason = '';
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.deleteReason = '';
  }

  confirmDelete() {
    if (!this.deleteReason || this.deleteReason.trim().length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Debe ingresar un motivo para la eliminación.'
      });
      return;
    }
    this.isDeleting = true;
    this.usersService.deleteCustomer(this.username, this.deleteReason.trim()).subscribe(
      res => {
        this.isDeleting = false;
        this.showDeleteModal = false;
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Usuario ' + this.username + ' marcado como eliminado correctamente.'
        });
        this.router.navigate(['ganalottodo', 'usuarios', 'ganalottodo']);
      },
      error => {
        this.isDeleting = false;
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Error al eliminar el usuario.'
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/usuarios-ganalottodo/ganalottodo-user/ganalottodo-user.component.ts